import useFetch from '../../../hooks/useFetch';
import authenticationApi from '../authenticationApi';

export default function useLoginApi() {
    return useFetch(authenticationApi.login);
}
